<template>
  <canvas id="myChart" class="mychart" ></canvas>
</template>

<script>
import { Chart, registerables } from "chart.js";

export default {
  props: ['affiliateSalesSummaryDetailDailyList'],
  data() {
    return {
      chartData: [],
      chartLabel: [],
    }
  },
  methods: {
    page() {
      this.$router.push({name: 'TestWalletDetail'})
    },
    setData() {
      this.chartLabel.splice(0, this.chartLabel.length);
      this.chartData.splice(0, this.chartData.length);
      for (var i = 0; i < this.affiliateSalesSummaryDetailDailyList.length; i++) {
        this.chartLabel.push(this.affiliateSalesSummaryDetailDailyList[i].targetDay + '日');
        this.chartData.push(this.affiliateSalesSummaryDetailDailyList[i].numberOfVisitor);
      }
      this.horizontalBar();
    },
    horizontalBar() {
      const ctx = document.getElementById('myChart').getContext('2d');
      const myChart = new Chart(ctx, {
        type: 'bar',
        // plugins: [ChartPluginTotalLsbel.totalLabels],
        data: {
          datasets: [
            {
              label: '',
              data: this.chartData,
              datalabels: {
                display: true
              },
              backgroundColor: '#4F68D4'
            }
          ],
          labels: this.chartLabel,
        },
        options: {
          legend: {
            // グラフ上のlabel（datasets）を非表示
            display: false
          },
          scales: {
            yAxes: [
              {
                ticks: {
                  min: 0,
                  stepSize: 10,
                },
                display: true,
                stacked: false,
                gridLines: {
                  // offsetGridLines: false,
                  display: false
                },
              }
            ],
            xAxes: [
              {
                ticks: {
                  min: 0,
                  stepSize: 1000,
                  // 下のラベルの数値をカンマ区切り
                  callback(label, index, labels) { /* ここです */
                    return label.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                  },
                  afterUpdate(axis) {
                    console.log('axis');
                    console.log(axis);
                  }
                },
              }
            ],
          },
          tooltips: {
            // グラフをクリックした際に発火
            callbacks: {
              label: function(tooltipItem, data) {
                return tooltipItem.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
              }
            }
          }
        }
      });
    },
  },
  mounted() {
    this.setData();
  },
  watch: {
    affiliateSalesSummaryDetailDailyList() {
      this.setData();
    }
  }
};
</script>

<style scoped>
.mychart {
  margin-bottom: 40px;
  width: 100%;
}
/* .chart {
  border: 1px solid #ccc;
  margin-top: 24px;
}
.mychart {
  padding: 8px 4px;
} */
</style>



// WEBPACK FOOTER //
// src/components/wallet/ChartAccessDetail.vue